import { HotelPriceAdjustments } from "@website/accommodation-ui/hotel-card-new/hotel-card.types";

export type SnappProDisplayPricing = {
  price: number;
  priceOff?: number;
  snappProDiscountPercentage?: number;
};

type CalculateSnappProDisplayPricingParameters = {
  price: number;
  priceOff?: number;
  adjustments?: HotelPriceAdjustments;
};

export const calculateSnappProDisplayPricing = ({
  price,
  priceOff,
  adjustments
}: CalculateSnappProDisplayPricingParameters): SnappProDisplayPricing => {
  if (!adjustments) return { price, priceOff };

  const finalPrice = priceOff && priceOff > 0 ? priceOff : price;
  const priceOffWithoutSnappPro = finalPrice - adjustments.snapp_pro;

  if (adjustments.snapp_pro >= 0 || price <= 0 || priceOffWithoutSnappPro <= 0)
    return { price, priceOff: priceOffWithoutSnappPro };

  return {
    price,
    priceOff: priceOffWithoutSnappPro,
    snappProDiscountPercentage: Math.ceil(
      (Math.abs(adjustments.snapp_pro) * 100) / priceOffWithoutSnappPro
    )
  };
};
